// extracted by mini-css-extract-plugin
module.exports = {"categoryGroup":"style_categoryGroup__7yedX","active":"style_active__1__qu"};